(function($) {$(document).ready(function() {

	$('.table-accord__title').on('click', event => {
		if (window.innerWidth >= 768) return;

		const $this = $(event.target);
		
		$this
			.parent()
			.toggleClass('open')
			.find('.table-accord__main')
			.slideToggle();
	});

	$('.table-accord__item.open-on-load')
		.addClass('open')
		.find('.table-accord__main')
		.show();

});;jQueryBridget("flickity", Flickity, $);})(window.NEW_jquery);